var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card-title",
        {
          staticClass: "pt-0"
        },
        [_vm._v(" Viewing Support Ticket #" + _vm._s(_vm.ticketid) + " ")]
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                sm: "12",
                md: "12"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-loading",
                        {
                          attrs: {
                            loading: _vm.loading
                          }
                        },
                        [
                          _c("ticket-details", {
                            attrs: {
                              ticket: _vm.ticket,
                              validated: !_vm.ticket.validation_required
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading,
                    "class-list": ["fill-height"]
                  }
                },
                [
                  _c("ticket-reply", {
                    attrs: {
                      ticketid: _vm.ticketid,
                      validated: !_vm.ticket.validation_required,
                      contacts: _vm.ticket.recipients
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.ticket.validation_required
            ? _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("ticket-validation", {
                    attrs: {
                      ticketid: _vm.ticketid,
                      validated: !_vm.ticket.validation_required
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading,
                    type: "article"
                  }
                },
                [
                  _c("posts", {
                    attrs: {
                      ticketid: _vm.ticketid,
                      posts: _vm.ticket.posts
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }